import React from "react";
import { TickIcon } from "components/SVG/TickIcon";
import { CloseIcon } from "components/SVG";
import {
  toggleButtonLeft,
  toggleButtonRight,
  toggleIconOn,
  toggleIconOff
} from "./MembershipToggleCard.css";
import { color } from "lib/theme/theme.css";
import { colours } from "@shared/ui.design-system";

type Props = {
  toggled: boolean;
  onToggleCallback: () => void;
  loading: boolean;
};

export const MembershipToggleButton: React.FC<Props> = ({
  toggled,
  loading,
  onToggleCallback
}) => {
  return (
    <button
      data-testid="MembershipToggleButton"
      type="button"
      role="switch"
      tabIndex={0}
      aria-checked={toggled}
      className={toggled ? toggleButtonRight : toggleButtonLeft}
      disabled={loading}
      onClick={() => onToggleCallback()}
    >
      {toggled ? (
        <TickIcon
          height={20}
          width={20}
          data-testid="MembershipToggleButton-tick-icon"
          className={toggleIconOn}
          fill={colours.success.medium}
        />
      ) : (
        <CloseIcon
          height={20}
          width={20}
          data-testid="MembershipToggleButton-close-icon"
          fill={color.contentNeutralSecondary}
          className={toggleIconOff}
        />
      )}
    </button>
  );
};
